import Handlebars from 'handlebars';
import 'jqueryEditable';
import JEditable from "jqueryEditable";
import CustomTagEditable from "libs/jquery-editable/modules/custom.tag.editable";

class FormattedSelectEditable extends CustomTagEditable {
    element(settings, original) {
        var select = $('<select />');
        $(this).append(select);
        return (select);
    }

    content(data, settings, original) {
        if (!data || data === "Loading...") return;
        const json = String === data.constructor ? JSON.parse(data) : data;

        const classes = $(original).attr("class");
        if (classes) {
            const classesArray = classes.split(" ");
            const tmplClassesArray = classesArray.filter(s => s.indexOf("tmpl:") === 0);
            if (tmplClassesArray.length > 0) {
                const tmpl = tmplClassesArray[0].substring(5);
                if (Handlebars.partials[tmpl]) {
                    Object.keys(json)
                        .filter(key => 'selected' !== key)
                        .forEach(key => {
                            const content = json[key];

                            const templateData = String !== content.constructor
                                ? content
                                : {
                                    key: key,
                                    value: content
                                };

                            json[key] = Handlebars.partials[tmpl](templateData);
                        });
                }
            }
        }
        settings.transformed_data = json;
        Object.keys(json)
            .filter(key => 'selected' !== key)
            .forEach(key => $('<option />').val(key).append(json[key]).appendTo($('select', this)));

        /* Loop option again to set selected. IE needed this... */
        $('select', this).children().each(function () {
            if ($(this).val() === json['selected'] ||
                $(this).text() === $.trim(original.revert)) {
                $(this).attr('selected', 'selected');
            }
        });
    }
}

JEditable.addInputType('formattedselect', FormattedSelectEditable);